import React, { Component } from "react";
import {
  Sidebar,
  SidebarHeader,
  SideBar,
  SidebarLeft,
  SidebarRight,
} from "../layouts/layout1";
import Title from "../title/title";
import Heading from "../heading/heading";
import SectionStart from "../sectionStart/sectionStart";
import Analytics from "./analytics";
import { connect } from "react-redux";
// Removed date picker CSS imports - packages were removed
// import { DateRangePicker } from "react-dates"; // Package removed
// Simple date range picker replacement
const DateRangePicker = ({
  startDate,
  endDate,
  onDatesChange,
  focusedInput,
  onFocusChange,
}) => (
  <div>
    <input
      type="date"
      value={startDate?.format("YYYY-MM-DD")}
      onChange={(e) => onDatesChange({ startDate: moment(e.target.value) })}
    />

    <input
      type="date"
      value={endDate?.format("YYYY-MM-DD")}
      onChange={(e) => onDatesChange({ endDate: moment(e.target.value) })}
    />
  </div>
);

import moment from "moment";
import { checkIfAnalyticsAreEnabled } from "../../actions";
import { checkIfMediaQueryMatches } from "../../constants/misc";

class AnalyticsOverview extends Component {
  Sidebar = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      fromDate: new Date(
        new Date(new Date().setDate(new Date().getDate() + 1)).setMonth(
          new Date().getMonth() - 1
        )
      ),
      toDate: new Date(),
      focusedInput: null,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.props.checkIfAnalyticsAreEnabled({});
    }, 1);
  }

  falseFunc = () => false;

  render() {
    const {
      analyticsAreEnabled,
      checkingIfAnalyticsAreEnabled,
      applicationStatus,
    } = this.props;

    if (
      checkingIfAnalyticsAreEnabled ||
      !analyticsAreEnabled ||
      applicationStatus !== "PRODUCTION"
    ) {
      return null;
    }

    const { toDate, fromDate, focusedInput } = this.state;

    return (
      <SectionStart>
        <SideBar>
          <SidebarLeft>
            <SidebarHeader style={{ marginBottom: 16 }}>
              <Title type="section">
                <Heading
                  style={{ marginBottom: "1rem" }}
                  level="2"
                  className="display-effect"
                >
                  {"Analytics"}
                </Heading>
              </Title>
              <Title type="small">Date range:</Title>
              <div className="tag-action">
                <div
                  className={"tag"}
                  style={{ padding: "14px 20px 14px 20px" }}
                >
                  <DateRangePicker
                    daySize={
                      checkIfMediaQueryMatches("(max-width: 768px)") ? 30 : 39
                    }
                    numberOfMonths={
                      checkIfMediaQueryMatches("(max-width: 768px)") ? 1 : 2
                    }
                    displayFormat={"DD-MM-YYYY"}
                    hideKeyboardShortcutsPanel={true}
                    isOutsideRange={this.falseFunc}
                    startDate={fromDate ? moment(fromDate) : null}
                    startDateId="from"
                    endDate={toDate ? moment(toDate) : null}
                    endDateId="to"
                    onDatesChange={({ startDate, endDate }) =>
                      this.setState({
                        fromDate: startDate ? startDate.toDate() : fromDate,
                        toDate: endDate ? endDate.toDate() : toDate,
                      })
                    }
                    focusedInput={focusedInput}
                    onFocusChange={(focusedInput) =>
                      this.setState({ focusedInput })
                    }
                  />
                </div>
              </div>
            </SidebarHeader>
          </SidebarLeft>
          <SidebarRight>
            <Analytics
              fromDate={fromDate}
              toDate={toDate}
              applicationId={this.props.applicationId}
            />
          </SidebarRight>
        </SideBar>
      </SectionStart>
    );
  }
}

const mapStateToProps = (state) => ({
  analyticsAreEnabled: state.analytics?.analyticsAreEnabled,
  checkingIfAnalyticsAreEnabled: state.analytics?.checkingIfAnalyticsAreEnabled,
});

const mapDispatchToProps = (dispatch) => ({
  checkIfAnalyticsAreEnabled: (payload) => {
    dispatch(checkIfAnalyticsAreEnabled(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsOverview);
